import React, {useState} from 'react';
import {StyleSheet, View, ViewStyle} from 'react-native';
import {SurfaceButton} from '../index';

export interface SurfaceButtonItem {
  title: string;
  badgeValue?: string;
}

interface Props {
  buttonTexts?: string[];
  buttonItems?: SurfaceButtonItem[];
  selectedIndex: number | null;
  setSelectedIndex(value: number): void;
  itemContainerStyle?: ViewStyle;
  // restricts width to its child if true. default: false
  itemWidthFitsChildren?: boolean;
  itemTestIdPrefix?: string;
  isInverse?: boolean;
  isHorizontal?: boolean;
  containerStyle?: ViewStyle;
}

export const SurfaceButtonSingleSelectGroup = (props: Props) => {
  const [selectedIndex, setSelectedIndex] = useState(props.selectedIndex);
  const isHorizontal = props.isHorizontal ?? false;
  let itemWidthFitsChildren = props.itemWidthFitsChildren ?? false;
  let viewStyle: ViewStyle = {};
  if (isHorizontal) {
    viewStyle = styles.containerHorizontal;
    itemWidthFitsChildren = true;
  }
  let buttonItems: SurfaceButtonItem[] = [];
  if (props.buttonTexts) {
    buttonItems = props.buttonTexts.map(text => ({
      title: text,
    }));
  } else if (props.buttonItems) {
    buttonItems = props.buttonItems;
  }
  return (
    <View style={props.containerStyle}>
      <View style={viewStyle}>
        {buttonItems.map((buttonItem, index) => {
          let itemKey = 'SurfaceButton' + index.toString();
          if (props.itemTestIdPrefix) {
            itemKey = props.itemTestIdPrefix + index.toString();
          }
          return (
            <SurfaceButton
              key={itemKey}
              text={buttonItem.title}
              badgeValue={buttonItem.badgeValue}
              onPress={() => {
                props.setSelectedIndex(index);
                setSelectedIndex(index);
              }}
              onPressIn={() => {
                setSelectedIndex(index);
              }}
              onPressOut={() => {
                setSelectedIndex(props.selectedIndex);
              }}
              isActive={selectedIndex === index}
              isInverse={props.isInverse}
              containerStyle={props.itemContainerStyle}
              widthFitsChildren={itemWidthFitsChildren}
              testID={itemKey}
            />
          );
        })}
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  containerHorizontal: {
    flexDirection: 'row',
    flexWrap: 'wrap',
  },
});
